<div class="location-dialog">
  <div class="location-dialog-header flex-between-center">
    <p class="m-0 font-bold">
      <i class="far fa-map-marker-alt pr-2"></i>
      {{ title }}
    </p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="location-dialog-body flex-column flex-wrap flex-start-start">
    <p class="mb-2">{{ subTitle }}</p>

    <div class="ui-g p-0 width-100p mt-3 mb-4">
      <div class="ui-g-12 p-0 width-100p">
        <div class="ui-g-6 py-0 pl-0 pr-4">
          <div class="flex-start-center">
            <i class="far fa-warehouse font-gray-45 pr-2"></i>

            <div class="width-100p">
              <app-dropdown id="location-warehouse" listId="location-warehouse" field="name" placeholder="Warehouse*"
                label="Warehouse*" itemWidth="150px" scrollHeight="204px" editableItemIdKey="_id"
                editFieldLabel="Add warehouse" editFieldMaxLength="18" [disabled]="isMultiLocationEnabled"
                [closeOnSelection]="true" [fontSize]="14" [floatingLabel]="true"
                [hasEditableField]="!isWarehouseEditMode" [value]="location?.warehouse" [isDropdownIconVisible]="true"
                [options]="warehouses" [errorMessage]="fieldErrors.warehouse" [hasCustomItemTemplate]="true"
                [hasError]="!!fieldErrors.warehouse" (appSelect)="handleChange('warehouse', $event)"
                (appSave)="handleCreateWarehouse($event)" [hasEditableFieldIndication]="true">
                <ng-template let-item appTemplate="item">
                  <div class="appt-color-wrapper flex-between-center flex-row">
                    <div class="appt-color-label">
                      <span>{{ item?.name }}</span>
                    </div>
                    <div class="appt-color-edit flex-center-center">
                      <i class="fas fa-pencil font-12 p-1"
                        (click)="$event.stopPropagation(); showEditOption('warehouse', item)"></i>
                    </div>
                  </div>
                </ng-template>
                <ng-template let-item appTemplate="footer">
                  <div class="auto-complete-item-create" *ngIf="isWarehouseEditMode">
                    <div class="flex-between-center flex-wrap bg-body">
                      <app-input theme="light" [fontSize]="12" [hasBorderBottomOnActive]="false"
                        [value]="updatedWarehouse.name" (appChange)="handleEditFieldChange('warehouse', $event)">
                      </app-input>
                      <div class="add-field-action-modifier">
                        <span class="float-right pr-1">
                          <button class="btn-sm btn-white"
                            (click)="handleEditModeCancel('warehouse', $event)">Cancel</button>
                          <button class="btn-sm btn-primary ml-2" (click)="updateWarehouse($event)"
                            [disabled]="isSavingWarehouse">Save</button>
                          <i class="fal fa-spinner rotate" *ngIf="isSavingWarehouse"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-dropdown>
            </div>
          </div>
        </div>

        <div class="ui-g-6 p-0">
          <div class="flex-start-center">
            <i class="far fa-columns font-gray-45 pr-2"></i>

            <div class="width-100p">
              <app-dropdown id="location-aisle" listId="location-aisle-item" field="name" placeholder="Aisle*"
                label="Aisle*" itemWidth="150px" scrollHeight="204px" editableItemIdKey="_id" editFieldLabel="Add aisle"
                [hasEditableField]="!isAisleEditMode" editFieldMaxLength="18" [closeOnSelection]="true" [fontSize]="14"
                [floatingLabel]="true" [options]="location?.warehouse?.aisles" [minCreateStrLength]="1"
                [value]="location?.aisle" [isDropdownIconVisible]="true" [disabled]="!location.warehouse"
                [errorMessage]="fieldErrors.aisle" [hasCustomItemTemplate]="true" [hasError]="!!fieldErrors.aisle"
                (appSelect)="handleChange('aisle', $event)" [hasEditableFieldIndication]="true"
                (appSave)="onCreateAisle($event)">
                <ng-template let-item appTemplate="item">
                  <div class="appt-color-wrapper flex-between-center flex-row">
                    <div class="appt-color-label">
                      <span>{{ item?.name }}</span>
                    </div>
                    <div class="appt-color-edit flex-center-center">
                      <i class="fas fa-pencil font-12 p-1"
                        (click)="$event.stopPropagation(); showEditOption('aisle', item)"></i>
                    </div>
                  </div>
                </ng-template>
                <ng-template let-item appTemplate="footer">
                  <div class="edit-color-label flex-column" *ngIf="isAisleEditMode">
                    <app-input theme="light" [fontSize]="12" [hasBorderBottomOnActive]="false"
                      [value]="updatedAisle.name" (appChange)="handleEditFieldChange('aisle', $event)"></app-input>

                    <div class="add-field-action-modifier">
                      <span class="float-right pr-1">
                        <button class="btn-sm btn-white" (click)="handleEditModeCancel('aisle', $event)">Cancel</button>
                        <button class="btn-sm btn-primary ml-2" (click)="updateAisle($event)"
                          [disabled]="isSavingAisle">Save</button>
                        <i class="fal fa-spinner rotate" *ngIf="isSavingAisle"></i>
                      </span>
                    </div>
                  </div>
                </ng-template>
              </app-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="ui-g-12 p-0 width-100p mt-35">
        <div class="ui-g-6 p-0 py-0 pl-0 pr-4">
          <div class="flex-start-center">
            <i class="far fa-boxes font-gray-45 pr-2"></i>

            <div class="width-100p">
              <app-input id="location-bin" placeholder="Bin*" maxLength="18" label="Bin*" styleClass="pl-0"
                styleClassError="top-38" styleClassLabel="pl-0" styleClassInput="pl-0 pr-2" [floatingLabel]="true"
                [value]="location?.bin" [errorMessage]="fieldErrors.bin" [isInvalid]="!!fieldErrors.bin"
                (appChange)="handleChange('bin', $event)">
              </app-input>
            </div>
          </div>
        </div>
        <div class="ui-g-6 p-0">
          <app-switch-pill id="sidebar-customer-active-switch" position="end" styleClassLabel="font-gray-35"
            [fontSize]="12" [label]="location.isActive ? 'Active' : 'Inactive'" [isActive]="location?.isActive"
            (appChange)="handleSwitchChange($event)">
          </app-switch-pill>
        </div>
      </div>
    </div>
  </div>

  <div class="location-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>
    <button class="btn btn-primary btn-submit" [disabled]="isCreatingOrUpdatingLocation" (click)="handleSubmit()">
      Save
      <i class="fal fa-spinner rotate" *ngIf="isCreatingOrUpdatingLocation"></i>
    </button>
  </div>
</div>
